<!-- AlertModal.vue -->
<template>
    <b-modal v-model="showModal" size="md" hide-footer centered header-class="WorkApplicationViewModalHeaderVariant"
        header-text-variant="white" :no-close-on-backdrop="true"
        @shown="setApplicationHomeInfo(selectApplication, shainName, approvalUserName, proxyFlg)" :title="setHeaderTitle()" v-bind="setClearInfo()">
        <!--承認済の時は編集できない-->
        <template v-slot:default>
            <div class="text-black">
                <div>
                    <div class="d-flex">
                        <div class="w-100">
                            <!-- 作業者 -->
                            <div class="WorkM_InputGroupArea">
                                <div class="d-flex">
                                    <div class="WorkM_InputGroup_ItemLabel">作業者</div>
                                </div>
                                <div>
                                    <b-input disabled :value="shainName"></b-input>
                                </div>
                            </div>
                            <!-- 日付 -->
                            <div class="WorkM_InputGroupArea mt-1">
                                <div class="d-flex">
                                    <div class="WorkM_InputGroup_ItemLabel">日付</div>
                                </div>
                                <div>
                                    <b-form-datepicker :value="rewriteApplicationDate"
                                        :date-format-options="{
                                            year: 'numeric',
                                            month: '2-digit',
                                            day: '2-digit',
                                            weekday: 'short'
                                        }" size="sm" placeholder="YYYY/MM/DD" :state="isDateState"
                                        aria-describedby="input-live-feedback"
                                        :disabled="isOnlyview()"></b-form-datepicker>
                                </div>
                                <div class="d-flex flex-row-reverse" style="height:27px;">
                                    <div v-if="!emptyCheck(rewriteApplicationDate)"
                                        style="font-size: 0.9rem; padding-top:0.15rem;">
                                        {{ "（" + rewriteApplicationDateType + "）" }}
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="WorkM_ApplicationEditSummaryArea ml-3 border rounded-sm" style="min-width:120px;">
                            <div class="WorkM_InputGroup_ItemLabel">有休残</div>
                            <div class="ml-1" style="font-size: 0.9rem">
                                {{ applicationRemainInfo.remainPaidHolidayDays }} ({{
                                    applicationRemainInfo.paidLeaveYealyDays }})
                            </div>
                            <div class="WorkM_InputGroup_ItemLabel mt-1">振休残</div>
                            <div class="ml-1" style="font-size: 0.9rem">
                                {{ applicationRemainInfo.remainSubstituteHolidayTime }} ({{
                                    applicationRemainInfo.remainSubstituteHolidayDays }})
                            </div>
                            <div class="WorkM_InputGroup_ItemLabel mt-1">残業</div>
                            <div class="ml-1" style="font-size: 0.9rem">
                                {{ applicationRemainInfo.overtimeWorkTime }} ({{
                                    applicationRemainInfo.overtimeMonthlyMaxHours }})
                            </div>
                        </div>
                    </div>

                    <div v-for="workInfoItem in todayWorkInfo" :key="workInfoItem.ditailNo">
                        <div class="WorkInfoItem my-2"
                            :class="!isAttendanceCheck(workInfoItem.workSegment) ? 'text-danger' : ''">
                            <!-- 時間 -->
                            <div class="WorkInfoItem_WorkTimeArea"
                                :class="!isAttendanceCheck(workInfoItem.workSegment) ? 'WorkInfoItem_WorkTimeArea_Red' : ''"
                                style="justify-content:center">
                                <div>{{ workInfoItem.startTime }}</div>
                                <div><b-icon icon="dash-lg" rotate="90" scale="0.8"></b-icon></div>
                                <div>{{ workInfoItem.endTime }}</div>
                            </div>
                            <!-- 内容 -->
                            <div class="WorkInfoItem_WorkContentArea">
                                <div class="WorkContent_ItemTypeArea" style="display: flex; flex-wrap:wrap;">
                                    <div class="WorkContent_ItemTypeArea_TypeLabel"
                                        :class="!isAttendanceCheck(workInfoItem.workSegment) ? 'WorkContent_ItemTypeArea_TypeLabel_Red' : ''">
                                        {{ getDispSegment(workInfoItem.workSegment) }}
                                    </div>
                                    <div v-if="workInfoItem.disasterKbn == 1" class="text-danger ml-2">災害</div>
                                </div>
                                <div class="mt-1">
                                    <div v-if="isAttendanceCheck(workInfoItem.workSegment) && workInfoItem.constructionCode !== '0'"
                                        class="WorkContent_ItemNote">
                                        <div v-if="workInfoItem.constructionCode !== '0'"
                                            class="WorkContent_ConstructionCode">[{{ workInfoItem.constructionCode }}]
                                        </div>
                                        <div v-if="workInfoItem.constructionName !== null"
                                            class="WorkContent_ConstructionName">{{ workInfoItem.constructionName }}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="WorkRegist_DispMemoArea"
                                            v-html="setLineFeedCode(workInfoItem.itemNote)"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--  -->
                    <div class="WorkM_InputGroupArea mt-3">
                        <div class="WorkM_InputGroup_ItemLabel">申請先</div>
                        <div style="height:27px;">
                            <div style="font-size:0.9rem;">{{ approvalUserName }}</div>
                        </div>
                    </div>
                    <!--  -->
                </div>
            </div>
            <div class="mt-4">
                <div v-if="isOnlyview()" class="d-flex justify-content-end">
                    <div variant="transparent" class="WorkM_Button WorkM_ButtonConfirm ml-2" @click="btnClose">確認終了
                    </div>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
/* eslint-disable */
import config from "../../const/config";
export default {
    name: "ApplicationEditModal",
    components: {  },
    props: {
        clickType: { type: Number, default: 0 },
        message: { type: String, default: "" },
        selectApplication: {
            type: Object,
            default: () => { }
        },
        shainName: { type: String, default: "" },
        approvalUserName: { type: String, default: "" },
    },
    data: function () {
        return {
            showModal: false,
            optionsWorkSegment: [],
            optionTimeHour: [
                { value: 0, text: "00" },
                { value: 1, text: "01" },
                { value: 2, text: "02" },
                { value: 3, text: "03" },
                { value: 4, text: "04" },
                { value: 5, text: "05" },
                { value: 6, text: "06" },
                { value: 7, text: "07" },
                { value: 8, text: "08" },
                { value: 9, text: "09" },
                { value: 10, text: "10" },
                { value: 11, text: "11" },
                { value: 12, text: "12" },
                { value: 13, text: "13" },
                { value: 14, text: "14" },
                { value: 15, text: "15" },
                { value: 16, text: "16" },
                { value: 17, text: "17" },
                { value: 18, text: "18" },
                { value: 19, text: "19" },
                { value: 20, text: "20" },
                { value: 21, text: "21" },
                { value: 22, text: "22" },
                { value: 23, text: "23" },
                { value: 24, text: "24" },
            ],
            optionTimeMin: [
                { value: 0, text: "00" },
                { value: 1, text: "01" },
                { value: 2, text: "02" },
                { value: 3, text: "03" },
                { value: 4, text: "04" },
                { value: 5, text: "05" },
                { value: 6, text: "06" },
                { value: 7, text: "07" },
                { value: 8, text: "08" },
                { value: 9, text: "09" },
                { value: 10, text: "10" },
                { value: 11, text: "11" },
                { value: 12, text: "12" },
                { value: 13, text: "13" },
                { value: 14, text: "14" },
                { value: 15, text: "15" },
                { value: 16, text: "16" },
                { value: 17, text: "17" },
                { value: 18, text: "18" },
                { value: 19, text: "19" },
                { value: 20, text: "20" },
                { value: 21, text: "21" },
                { value: 22, text: "22" },
                { value: 23, text: "23" },
                { value: 24, text: "24" },
                { value: 25, text: "25" },
                { value: 26, text: "26" },
                { value: 27, text: "27" },
                { value: 28, text: "28" },
                { value: 29, text: "29" },
                { value: 30, text: "30" },
                { value: 31, text: "31" },
                { value: 32, text: "32" },
                { value: 33, text: "33" },
                { value: 34, text: "34" },
                { value: 35, text: "35" },
                { value: 36, text: "36" },
                { value: 37, text: "37" },
                { value: 38, text: "38" },
                { value: 39, text: "39" },
                { value: 40, text: "40" },
                { value: 41, text: "41" },
                { value: 42, text: "42" },
                { value: 43, text: "43" },
                { value: 44, text: "44" },
                { value: 45, text: "45" },
                { value: 46, text: "46" },
                { value: 47, text: "47" },
                { value: 48, text: "48" },
                { value: 49, text: "49" },
                { value: 50, text: "50" },
                { value: 51, text: "51" },
                { value: 52, text: "52" },
                { value: 53, text: "53" },
                { value: 54, text: "54" },
                { value: 55, text: "55" },
                { value: 56, text: "56" },
                { value: 57, text: "57" },
                { value: 58, text: "58" },
                { value: 59, text: "59" },
            ],
            messageHourState: null,
            isAllocationCalc: true, // 工事CD入力要否フラグ
            isHourState: null,
            messageConstruction: null,
            isConstruction: true,
            isConstructionState: true,
            noteMaxLength: 40, // 事由MAX文字数
            constructionCodeMaxLength: 8, // 工事コードMAX文字数

            isChanged: false, // フォームの中、一つでも変更したか

            shiftStart: null,
            shiftEnd: null,

            todayWorkInfo: {},


            targetDateInfo: {
                date: null,
                dateType: null,
            },
            applicationRemainInfo: {
                shainCd: 0,
                remainPaidHolidayDays: 0,
                paidLeaveYealyDays: 0,
                remainSubstituteHolidayTime: null,
                remainSubstituteHolidayDays: 0,
                overtimeWorkTime: null,
                overtimeMonthlyMaxHours: null
            },

            // 初期データ
            originallyInfo: {
                kbn: 0,
                date: null,
                dateType: null,
                start: null,
                end: null,
                startHour: null,
                startMin: null,
                endHour: null,
                endMin: null,
                substituteWork: null,
                substituteHoliday: {
                    date: null,
                    start: null,
                    end: null
                },
                constructionCode: null,
                constructionName: null,
                reason: null,
                disasterKbn: null,
            },

            detailNo: 0,
            shainCd: 0, // 社員番号
            shainName: "",
            rewriteApplicationKbn: 0, // 区分
            rewriteApplicationDate: "", // 日付
            rewriteApplicationDateTypeCode: 0,
            rewriteApplicationDateType: null, // (平日、休日、公休)
            rewriteSubstituteHoliday: null, // 振休入力欄
            substituteHolidayInfo: { // 振休情報
                date: null,
                start: null,
                end: null,
            },
            rewriteSubstituteWork: null, // 振出入力欄
            substituteWorkInfo: { // 振出情報
                detailNo: 0,
                date: null,
                start: null,
                end: null,
                time: null,
            },
            rewriteStartHour: 0, // 開始時間
            rewriteStartMin: 0, // 開始分
            rewriteEndHour: 0, // 終了時間
            rewriteEndMin: 0, // 終了分
            rewriteConstructionCode: 0, // 工事cd
            rewriteConstructionName: null, // 工事名
            rewriteNote: "", // 事由
            rewriteDisasterKbn: 0, // 災害フラグ

            proxyFlg: false, // 代理フラグ
            approvalUserCd: null, // 申請先番号
            approvalUserName: null, // 申請先名
            approvalKbn: 0, // 承認結果CD

            dailyReportTermStart: "", // 日報期間開始日(yyyy/MM/dd)
            isDateState: null,
            messageDateState: "",
            isSegmentState: null,
            messageSegmentState: "区分を選択してください",
            isDisasterFlg: false, // 災害有効フラグ
            searchConstructionNumber: 2, // 工事検索ポップアップ_画面種別
        };
    },
    computed: {
        setAttendanceCheck: function () {
            let isAttendanceCheck = this.isAttendanceCheck();
            if (this.rewriteApplicationKbn > 0 && !this.emptyCheck(this.rewriteApplicationKbn)) {
                if (!isAttendanceCheck) {
                    this.isConstructionState = null;
                }
                this.timeState();
            }
            return isAttendanceCheck;
        },
        setKbnHolidayCheck: function () {
            return this.isSubstituteHolidayCheck(this.rewriteApplicationKbn);
        },
        setKbnWorkCheck: function () {
            return this.isSubstituteWorkCheck(this.rewriteApplicationKbn);
        },
        setOptionStartTimeMin: function () {
            if (this.rewriteStartHour == 24) {
                this.setStartTimeMin(0);
                return [{ value: 0, text: "00" }];
            }
            else {
                return this.optionTimeMin;
            }
        },
        setOptionEndTimeMin: function () {
            if (this.rewriteEndHour == 24) {
                this.setEndTimeMin(0);
                return [{ value: 0, text: "00" }]
            }
            else {
                return this.optionTimeMin;
            }
        },
        dateStateMessage: function () {
            return "当月日報期間以降(" + this.dailyReportTermStart + ")で設定してください。";
        },
    },
    mounted: function () {
        this.optionsWorkSegment = config.OPTIONS.APPLIATION_SEGMENT;
        this.searchConstructionNumber = config.VALUE.DISPLAY_TYPE_APPLICATION;
    },
    methods: {
        openModal: function () {
            this.showModal = true;
            this.isSegmentState = null;
            this.isDateState = null;
            this.isConstructionState = true;
            this.isAllocationCalc = this.$store.state.flg_allocation_calc;
            this.isHourState = null;
        },
        handleOk: function () {
            // 初期表示フラグをfalseにする
            this.isInitialDisplay = false;
            this.showModal = false;
            this.$emit("handleOk");
        },
        // propsの情報を基に画面に表示する内容をセット
        setApplicationHomeInfo: function (items, shainName, approvalUserName) {
            console.debug("items: " + JSON.stringify(items));
            console.debug("Object.keys(items).length  === 0" + Object.keys(items).length === 0);
            this.shainName = shainName;
            console.debug("items.todayInfo.date:"+items.todayInfo.date);
            this.rewriteApplicationDate = this.getStrDateHyphen(items.todayInfo.date);
            this.rewriteApplicationDateType = items.todayInfo.dateType;
            this.shiftStart = items.workAttendanceInfo.shiftStart;
            this.shiftEnd = items.workAttendanceInfo.shiftEnd;
            this.todayWorkInfo = items.workAttendanceInfo.workInfoList;
            this.approvalUserName = approvalUserName;
            // 有休残情報をセット
            this.applicationRemainInfo = items.applicationRemainInfo;
        },

        getDispSegment: function (segmentCd) {
            let optionSegment = config.OPTIONS.WORK_SEGMENT;
            let result = "";
            optionSegment.forEach((element) => {
                if (element.value == segmentCd) {
                    result = element.text;
                }
            });
            return result;
        },
        // ヘッダータイトルをセット
        setHeaderTitle: function () {
            const TITLE_APPLICATION_DETAIL = "報告詳細";
            return TITLE_APPLICATION_DETAIL;
        },
        // 事由 改行コードを<br>にする
        setLineFeedCode: function (msg) {
            let newMsg = msg?.replace(/\n/g, '<br>');
            return newMsg;
        },
        setClearInfo: function () {
            // 日付情報をセット
            this.rewriteApplicationDate = null;
            this.rewriteApplicationDateTypeCode = 0;
            this.rewriteApplicationDateType = null;
            // 区分情報をセット
            this.rewriteApplicationKbn = 0;
            //時間情報をセット
            this.rewriteStartHour = null;
            this.rewriteStartMin = null;
            this.rewriteEndHour = null;
            this.rewriteEndMin = null;
            // 工事情報をセット
            this.rewriteConstructionCode = null;
            this.rewriteConstructionName = null;
            // 事由情報をセット
            this.rewriteNote = null;
            // 災害情報をセット
            this.rewriteDisasterKbn = 0;
            // 振休振出情報をセット
            this.rewriteSubstituteWork = null;
            this.rewriteSubstituteHoliday = null;
            // 申請先情報をセット
            this.proxyFlg = false;
            this.approvalUserCd = null;
        },

        btnClose: function () {
            this.$emit("getApplicationRegistInfo");
            this.showModal = false;
            this.$emit("handleOk");
        },

        dateState() {
            if (this.isBeforeDailyreportTerm && !this.isOnlyview()) {
                this.isDateState = false;
                this.messageDateState = this.dateStateMessage;
            } else {
                this.isDateState = null;
            }
            return this.isBeforeDailyreportTerm;
        },


        // 空文字かチェック
        // true: 空文字
        // false: 空文字ではない
        emptyCheck(text) {
            if (text != null && text != "") {
                return false;
            }
            else {
                return true;
            }
        },

        // 出勤しているかチェックする
        // true：出勤
        // false：休み
        isAttendanceCheck: function (workSegment) {
            const WORK_SEGMENT_ATTENDANCE = 1; // 出勤
            const WORK_SEGMENT_HOLIDAY_TRANSFER = 11; // 休日出勤（振替）
            const WORK_SEGMENT_HOLIDAY_ALLOWANCE = 12; // 休日出勤（残業）
            const WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER = 21; // 公休出勤（振替）
            const WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE = 22; // 公休出勤（残業）

            if (workSegment != WORK_SEGMENT_ATTENDANCE
                && workSegment != WORK_SEGMENT_HOLIDAY_TRANSFER
                && workSegment != WORK_SEGMENT_HOLIDAY_ALLOWANCE
                && workSegment != WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER
                && workSegment != WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE
                && workSegment > 0) {
                return false;
            }
            else {
                return true;
            }
        },

        // 承認区分が未承認かチェック
        // true: 承認済または否認済
        // false: 未承認
        isApproved: function () {
            if (this.approvalKbn == config.VALUE.APPROVAL_TYPE_APPROVAL || this.approvalKbn == config.VALUE.APPROVAL_TYPE_REJECTION) {
                return true;
            } else {
                return false;
            }
        },
        // 承認画面から呼ばれたか
        isOnlyview: function () {
            return true;
        }
    },
    watch: {
        isChanged: {
            handler: function (newVal, oldVal) {
                console.debug("isChanged: " + newVal);
                if (newVal) {
                    // 再送信ボタン有効化
                }
            }
        },
    }
};
</script>
<style>
.WorkM_ApplicationEditSummaryArea {
    background: rgb(238, 238, 238) !important;
    border-color: rgb(206, 212, 218) !important;
    padding: 0.3rem;
    width: 35%;
    height: auto;
}

.WorkM_InputGroup_ItemLabel {
    font-size: 0.85rem;
    color: rgb(13, 91, 136);
    font-weight: 700;
    margin: 0;
}

.WorkM_InputTimeGroup {
    display: flex;
}

.WorkM_InputTime_ApplicationEditModal .WorkM_InputTimeGroup_InputItem {
    width: 3.5rem;
}

.WorkApplicationViewModalHeaderVariant {
    background-color:rgb(13, 91, 136)
    /* background-color: rgb(0, 128, 128); */
}

/* 
.disabled {
    opacity: 0.5;
} */


.text-black .form-control:disabled   {
  color: #495057;
}
.text-black .custom-select:disabled{
  color:#495057;
}
</style>